/* src/app/shared/order-form/order-form/order-form.component.scss */
.cw-timestamps-with-confirmation {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.cw-timestamps-block {
  flex: 0 1 auto;
}
/*# sourceMappingURL=order-form.component.css.map */
